import Proxy from '../Proxy';

class ExpensesProxy extends Proxy {
  /**
   * The constructor for the ArtistProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('expenses', parameters);
  }
}

export default ExpensesProxy;
